import { render, staticRenderFns } from "./ReportesForm.vue?vue&type=template&id=60a116df&"
import script from "./ReportesForm.vue?vue&type=script&lang=js&"
export * from "./ReportesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports